import React from 'react'
import PropTypes from 'prop-types'
import qs from 'qs'
import pickBy from 'lodash-es/pickBy'
import debounce from 'lodash-es/debounce'

const getDisplayName = function getDisplayName(Comp) {
	if (typeof Comp === 'string') {
		return Comp;
	}

	if (!Comp) {
		return '';
	}

	return Comp.displayName || Comp.name || 'Component';
};

export const withParams = DecoratedComponent => {
	const klass = class WithParams extends React.Component {
		constructor(props) {
			super(props);
			this.setParamsDebounced = debounce(this.setParams, 500);
		}

		qsParams() {
			const {location: {search}} = this.props;
			return qs.parse((search || '').replace(/\?/, ''));
		}

		matchParams() {
			const {match: {params}} = this.props;
			return params;
		}

		currentParams() {
			return {...this.qsParams(), ...this.matchParams()};
		}

		paramsPath(newParams) {
			const {routePath} = this.props;
			const mergedParams = pickBy({...this.currentParams(), ...newParams});
			if (routePath) {
				return routePath(mergedParams);
			} else {
				return `?${qs.stringify(mergedParams)}`;
			}
		}

		setParams(newParams) {
			const {history: {push}} = this.props;
			push(this.paramsPath(newParams));
		}

		render() {
			return (
				<DecoratedComponent
					{...this.props}
					params={this.currentParams()}
					paramsPath={this.paramsPath.bind(this)}
					setParams={this.setParams.bind(this)}
					setParamsDebounced={this.setParamsDebounced.bind(this)}
				/>
			);
		}
	};

	klass.displayName = `withParams(${getDisplayName(DecoratedComponent)})`;
	klass.propTypes = {
		history: PropTypes.shape({
			push: PropTypes.func.isRequired,
			replace: PropTypes.func.isRequired,
			createHref: PropTypes.func.isRequired
		}).isRequired,
		location: PropTypes.object.isRequired
	};
	return klass;
};

export default withParams;
